/* eslint-disable no-unused-vars */
// LocationPermissionModal.js
import React, { useState, useEffect } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { RiCloseLine, RiMapPinLine } from 'react-icons/ri';

const LocationPermissionModal = ({ show, onRetry, onCancel, loading, permissionStatus, permissionDenied, error }) => {
  const [platform, setPlatform] = useState('desktop');

  useEffect(() => {
    // Detect platform (iOS or Android for webapp)
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    if (/android/i.test(userAgent)) {
      setPlatform('android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform('ios');
    } else {
      setPlatform('desktop');
    }
  }, []);

  const isBlocked =
    permissionDenied ||
    permissionStatus === 'denied' ||
    (typeof error === 'string' && /denied|blocked/i.test(error));

  const getLocationInstructions = () => {
    if (platform === 'ios') {
      return {
        title: 'Enable Location on iOS',
        steps: [
          'Go to Settings → Safari → Location',
          'Set it to "Allow While Using the App" or "Ask"',
          'If already set, toggle it off and back on',
          'Return to this page and refresh'
        ]
      };
    } else if (platform === 'android') {
      return {
        title: 'Enable Location on Android',
        steps: [
          'Go to Settings → Apps → Browser/Chrome',
          'Tap on Permissions → Location',
          'Select "Allow only while using the app"',
          'Return to this page and refresh'
        ]
      };
    } else {
      return {
        title: 'Enable Location in Browser',
        steps: [
          'Click the location icon in the address bar',
          'Select "Allow" for location access',
          'Refresh the page if needed'
        ]
      };
    }
  };

  const instructions = getLocationInstructions();

  if (!show) return null;

  return (
    <Offcanvas 
      backdropClassName="blurred-backdrop-offcanvas" 
      show={show} 
      placement='bottom' 
      onHide={onCancel} 
      className="offcanvas-bottom offcanvasBG"
    >
      <Offcanvas.Header className='relative py-4'>
        <h1 className='britti fs_16 mb-0 text-center w-full'>Location Access Required</h1>
        <RiCloseLine onClick={onCancel} className='w-[24px] h-[24px] absolute right-5 cursor-pointer' />
      </Offcanvas.Header>
      
      <Offcanvas.Body>
        <div className='flex flex-col items-center h-100 sm:px-[15px]'>
          
          {/* Icon */}
          <div className='flex items-center justify-center w-[64px] h-[64px] bg-[#EBF1FF] rounded-full mb-4'>
            <RiMapPinLine className='w-[32px] h-[32px] text-[#335CFF]' />
          </div>

          {/* Instructions */}
          <div className='w-full mb-6'>
            <h2 className='text-start text-[#1F2937] fs_18 britti_bold mb-3'>
              {instructions.title}
            </h2>
            
            <ol className='list-decimal list-inside space-y-3 text-left'>
              {instructions.steps.map((step, index) => (
                <li key={index} className='txt_grey fs_15 text-[#525866] britti'>
                  {step}
                </li>
              ))}
            </ol>
          </div>

          {/* Continue Without Location Button */}
          <button
            onClick={onCancel}
            className='w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-[12px] britti_bold fs_16 hover:bg-gray-200 transition-colors'
          >
            Use Without Location
          </button>

        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default LocationPermissionModal;